import { useParams } from 'react-router';

import { RouterEntitiesId } from '@clearverify/constants';

export const useInviteParamId = () => {
  const { inviteId } = useParams<{ [RouterEntitiesId.invite]: string }>();

  return inviteId;
};
